export default __webpack_public_path__ + "static/media/et.383fca54.svg";